// @flow

import WebApi from '../WebApi';

import DiagnosticsActions from "../actions/DiagnosticsActions";

let DiagnosticsSource = {
	fetch() {
		return {
			remote(state) {
				return WebApi.getDiagnostics();
			},
			
			local() {
				return null;
			},
			
			success: DiagnosticsActions.fetchDone,
			error: DiagnosticsActions.fetchFailed
		};
	}
};

export default DiagnosticsSource;
